<template>
  <div class="header">
    <div class="index_right" v-show="right">
      <span @click="show">关闭</span>
      <p class="right_1">扫码关注</p>
      <el-image v-if="xcxm.img_path !== undefined" :src="imgPath + xcxm.img_path" fit="cover"></el-image>
      <p class="right_2" style="margin-bottom:20px">{{xcxm.img_name}}</p>
      <el-image v-if="ewm.img_path !== undefined" :src="imgPath + ewm.img_path" fit="cover"></el-image>
      <p class="right_2">{{ewm.img_name}}</p>
    </div>
    <div class="top">
      <div class="top_3">
        <a href="javascript:void(0);" @click="collect">收藏网站</a>|
        <a href="http://www.tlsjw.gov.cn/" target="_black">旧版网站</a>|
        <a href="javascript:void(0);" @click="index">设为首页</a>
      </div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-input class="onSearch" v-model.trim="formInline.search" placeholder="请输入关键字"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="onSubmit" type="primary" @click="onSubmit(formInline.search)">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="top2">
      <p><img src="@/assets/images/logo_1.png" />中共铁岭县纪律检查委员会<img style="margin-left:30px;" src="@/assets/images/logo_3.png" />铁岭县监察委员会</p>
      <span class="ma"><el-image v-if="xcxm.img_path !== undefined" :src="imgPath + xcxm.img_path" fit="cover"></el-image><br/>{{xcxm.img_name}}</span>
      <span class="ma"><el-image v-if="ewm.img_path !== undefined" :src="imgPath + ewm.img_path" fit="cover"></el-image><br/>{{ewm.img_name}}</span>
    </div>
    <div class="nav">
      <ul>
        <li @click="torouter(0)">首页</li>
        <li @click="tonnews(9)">新闻要闻</li>
        <li><a href="http://www.ccdi.gov.cn/fgk/index" target="_black">党纪法规</a></li>
        <li v-for="item in navList" :key="item.tob" @click="torouter(item.column_id)">
          {{ item.column_name }}
        </li>
        <!-- <li><a href="javascript:void(0)" target="_black">网络展馆</a></li> -->
      </ul>
    </div>
  </div>
</template>

<script>
  import "@/assets/css/header.css";
  import {imgPath,cityId} from "@/api/api"
  export default {
    name: "headers",
    data() {
      return {
        formInline: {
          search: "",
        },
        active:0,
        navList:[],
        xcxm:[],
        ewm:[],
        imgPath,
        cityId,
        right:true
      };
    },
    created(){
      this.httpPost();
    },
    methods: {
      httpPost(){
        const _this = this;
        // 导航
        this.$http({
          headers:"application/json; charset=utf-8",
          url: "/api/Index/GetNavi",
          data:{"city_id":cityId},
          success(res){
            _this.navList = res.extend.module_list;
          }
        });
        // 二维码
        this.$http({
          headers:"application/json; charset=utf-8",
          url: "/api/Index/GetEwm",
          data:{"city_id":cityId},
          success(res){
            _this.xcxm = res.extend.xcxm;
            _this.ewm = res.extend.ewm;
          }
        });
      },
      index() {
          alert("抱歉，您所使用的浏览器无法完成此操作，您需要手动设置为首页");
      },
      collect() {
          alert("抱歉，您所使用的浏览器无法完成此操作，请按 Ctrl+D 手动收藏！");
      },
      show(){
        this.right = false;
      },
      tonnews(e){
          let blank = this.$router.resolve({
            path: '/list/' + e,
          });
          window.open(blank.href,'_blank')
      },
      torouter(e) {
        if (e == "0") {
          let blank = this.$router.resolve({
            path: '/',
          });
          window.open(blank.href,'_blank')
        }
        else if (e == "4") {
          let blank = this.$router.resolve({
            path: '/xxgk/' + e,
          });
          window.open(blank.href,'_blank')
        }
        else if (e == "5") {
          let blank = this.$router.resolve({
            path: '/zcwj/' + e,
          });
          window.open(blank.href,'_blank')
        }
        else{
          let blank = this.$router.resolve({
            path: '/list/' + e,
          });
          window.open(blank.href,'_blank')
        }
      },
      onSubmit(value) {
        if(value == ""){
          alert("请输入关键字")
        }
        else{
          this.$router.push("/search/" + value);
        }
      },
    },
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/header.vue